import {MediaFileType} from "../enums/MediaFileType.ts";
import {Api} from "../api/api.ts";
import {RequestableImageSize} from "../components/requestableImageSize.ts";

export function target<T = HTMLInputElement>(e: Event) {
    return e.target as T;
}

export function getImageUrl(type: MediaFileType, id: number, quality: RequestableImageSize) {
    return `${Api.baseUrl}/media/image?mediaFileType=${type}&id=${id}&quality=${quality}`;
}
